;(function() {
  'use strict'

  angular.module('core.cardSurvey').directive('cardSurvey', directive)

  /* @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        onClick: '&',
      },
      templateUrl: 'card-survey.template.html',
      link: link,
    }

    function link(scope, elem) {
      elem.addClass('card-survey')
    }
  }
})()
